import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  AuthActions,
  AuthMultisiteIsolationService,
  AuthRedirectService,
  AuthRedirectStorageService,
  GlobalMessageService,
  OAuthLibWrapperService,
  RoutingService,
  StateWithClientAuth,
  UserIdService,
} from '@spartacus/core';
import { AsmAuthService, AsmAuthStorageService } from '@spartacus/asm/root';
import { of } from 'rxjs';
import { take, switchMap } from 'rxjs/operators';
import { CookieService } from '../../customServices/cookie.service';

@Injectable({
  providedIn: 'root',
})
export class KbAuthService extends AsmAuthService {
  cookieService = inject(CookieService);
  constructor(
    protected override store: Store<StateWithClientAuth>,
    protected override userIdService: UserIdService,
    protected override oAuthLibWrapperService: OAuthLibWrapperService,
    protected override authStorageService: AsmAuthStorageService,
    protected override authRedirectService: AuthRedirectService,
    protected override globalMessageService: GlobalMessageService,
    protected override routingService: RoutingService,
    protected override authMultisiteIsolationService?: AuthMultisiteIsolationService,
    protected authRedirectStorageService?: AuthRedirectStorageService
  ) {
    super(
      store,
      userIdService,
      oAuthLibWrapperService,
      authStorageService,
      authRedirectService,
      globalMessageService,
      routingService,
      authMultisiteIsolationService
    );
  }

  override coreLogout(): Promise<any> {
    return this.userIdService
      .isEmulated()
      .pipe(
        take(1),
        switchMap((isEmulated) => {
          if (isEmulated) {

            //clear cookiees on logout
            this.cookieService.deleteCookie('countryIsoCodeNA');
            this.cookieService.deleteCookie('languageIsoCodeNA');
            this.cookieService.deleteCookie('defaultCurrencyNA');
            this.authStorageService.clearEmulatedUserToken();
            this.userIdService.clearUserId();
            this.store.dispatch(new AuthActions.Logout());
            this.routingService.go({ cxRoute: 'home' });
            return of(true);
          } else {

            //clear cookiees on logout
            this.cookieService.deleteCookie('countryIsoCodeNA');
            this.cookieService.deleteCookie('languageIsoCodeNA');
            this.cookieService.deleteCookie('defaultCurrencyNA');
            this.setLogoutProgress(true);
            this.userIdService.clearUserId();
            this.routingService.go({ cxRoute: 'home' });

            return new Promise<void>((resolve) => {
              this.oAuthLibWrapperService.revokeAndLogout().finally(() => {
                this.store.dispatch(new AuthActions.Logout());
                this.setLogoutProgress(false);
                resolve();
              });
            });
          }
        })
      )
      .toPromise();
  }
}
